import { SelectionChangedEvent } from "ag-grid-community";
import { ChargeWaiverRegistrationEntity } from "domain/entity/ChargeWaiverRegistration/ChargeWaiverRegistrationEntity";
import { INITIAL_CHARGE_WAIVER_REGISTRATION_COL_DEF, transferRowData } from "presentation/constant/ChargeWaiverRegistration/ChargeWaiverRegistrationColumnDefinition";
import { ChargeWaiverRegistrationConstant } from "presentation/constant/ChargeWaiverRegistration/ChargeWaiverRegistrationConstant";
import { useChargeWaiverRegistrationVM } from "presentation/hook/ChargeWaiverRegistration/useChargeWaiverRegistrationVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeWaiverRegistrationTracked } from "presentation/store/ChargeWaiverRegistration/ChargeWaiverRegistrationProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const ChargeWaiverRegistrationTablePanel: React.FC = () => {
    const [chargeWaiverRegistrationState] = useChargeWaiverRegistrationTracked();
    const chargeWaiverRegistrationVM = useChargeWaiverRegistrationVM();
    const { chargeWaiverRegistrationList } = chargeWaiverRegistrationState;
    const gridRef: any = useRef(null);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        chargeWaiverRegistrationVM.updateSelectedRows(selectedRows);
    }, [chargeWaiverRegistrationVM])

    const handleRowDoubleClick = useCallback((entity: ChargeWaiverRegistrationEntity) => {
        chargeWaiverRegistrationVM.onRowDoubleClick(entity);
    }, [chargeWaiverRegistrationVM])

    const handleAdd = useCallback(() => {
        chargeWaiverRegistrationVM.onAddClick();
    }, [chargeWaiverRegistrationVM]);

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='chargeWaiverRegistration-table'
                isNewColumnSetting={true}
                headerLabel={ChargeWaiverRegistrationConstant.TITLE}
                columns={INITIAL_CHARGE_WAIVER_REGISTRATION_COL_DEF}
                data={transferRowData(chargeWaiverRegistrationList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: ChargeWaiverRegistrationEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [chargeWaiverRegistrationList, allowCreate, handleAdd, handleSelectionChange, handleRowDoubleClick])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(ChargeWaiverRegistrationTablePanel);
